import React from "react";
import { Helmet } from "react-helmet";
import HeaderThree from "../../../components/header/HeaderThree";

import CoreComponent20 from "../../../assets/Sub-component/CoreComponent20";
import CoreComponent2 from "../../../assets/Sub-component/CoreComponent2";
import Enterpertises2 from "../../../assets/Sub-component/Enterpertises2";
import OurLatestBlogs from "../../../assets/Sub-component/OurLatestBlogs";
import FooterTwo from "../../../components/footer/FooterTwo";
import CopyRightTwo from "../../../components/footer/CopyRightTwo";

import cost from "../../../assets/Flutter/Scalable-solution/Costeffective.svg";
import deploy from "../../../assets/Flutter/Scalable-solution/Deployment.svg";
import solution from "../../../assets/Flutter/Scalable-solution/Solution.svg";
import culture from "../../../assets/Flutter/Scalable-solution/working culture.svg";
import expert_flutter from "../../../assets/Flutter/Scalable-solution/Specialised_fluter_app.svg";

import dynamic from "../../../assets/Services/Web_design/Offer_custamizable/Dynamic_web.svg";
import resposnsive from "../../../assets/Services/Web_design/Offer_custamizable/Responsive_web.svg";
import WebDesigns from "../../../assets/Services/Web_design/Offer_custamizable/Web_design.svg";

import cusotm from "../../../assets/Services/Web_design/Partner_with/custom_web.svg";
import ecom from "../../../assets/Services/Web_design/Partner_with/Ecom_web.svg";
import mobile from "../../../assets/Services/Web_design/Partner_with/mobile_app_design.svg";
import uiuxs from "../../../assets/Services/Web_design/Partner_with/UIUX.svg";
import webspeed from "../../../assets/Services/Web_design/Partner_with/Web_speed.svg";
import wordpress from "../../../assets/Services/Web_design/Partner_with/wordpress_web.svg";

import CoreComponent14 from "../../../assets/Sub-component/CoreComponent14";
import WebDesignCore from "../../../assets/Sub-component/WebDesignCore";
import { Link } from "react-router-dom";

import API_Integration_Service from '../../../assets/Services/Angular_dev/API_Integration_Service.svg'
import Angular_Consulting from '../../../assets/Services/Angular_dev/Angular_Consulting.svg'
import Portal_Redesign from '../../../assets/Services/Angular_dev/Portal_Redesign.svg'
import Progressive_Web from '../../../assets/Services/Angular_dev/Progressive_Web.svg'
import Real_time from '../../../assets/Services/Angular_dev/Real-time_web.svg'
import Single_page from '../../../assets/Services/Angular_dev/Single-Page-Applications.svg'

import icon from '../../../assets/Services/Angular_dev/img.png'
import FaqHome from "../../../components/faq/FaqHome";
import launchingimage from '../../../assets/Launchingimage.png'
const AngularDevelopment = () => {
  const vertical = [
    {
      icon: cusotm,
      title: " AngularJS solutions",
      line: "line-hori",
    },
    {
      icon: ecom,
      title: "AngularJS Web Application",
      line: "line-hori",
    },
    {
      icon: mobile,
      title: "Plugin Solutions",
      line: "line-hori",
    },
    {
      icon: uiuxs,
      title: "Custom Portal Refinements",
      line: "line-hori",
    },
    {
      icon: webspeed,
      title: "AngularJS Interface Enhancement",
      line: "line-hori",
    },

    {
      icon: wordpress,
      title: "AngularJS eCommerce Platform",
    },
  ];
  
  const content100 = [
    {
      icon: Single_page,
      title: "Single-Page Applications",
      desc: "We create blazing-fast SPAs that dynamically load content to provide a seamless, app-like user experience. Better performance, less server load, and increased user engagement are the outcomes of this, all of which are essential for keeping visitors and increasing conversions.",
    },
    {
      icon: API_Integration_Service,
      title: "API Integration Service",
      desc: "Raiden optimally improves functionality and data transfer reliability by integrating APIs with effective Angular applications. This integration optimizes business operations by improving performance and decreasing disruptions to workflow. ",
    },
    {
      icon: Real_time,
      title: "Real-time web apps",
      desc: "Our live web apps eliminate the need for frequent page refreshes by updating them at regular intervals. Users can participate in interactive and effective workflows through chat rooms, productive tools, and user-friendly dashboards.",
    },
    {
      icon: Portal_Redesign,
      title: "Portal Redesign in Angular",
      desc: "Update your current portals with a comprehensive Angular redesign. We update antiquated user interfaces to create visually appealing, functional, and high-performing portals that increase accessibility, user satisfaction, and overall operational effectiveness.",
    },
    {
      icon: Angular_Consulting,
      title: "Angular Consulting for Enterprise",
      desc: "Raiden provides large organizations with strategic Angular consulting that guarantees appropriate development, long-term progress, and safety. Our architecture is guaranteed by experts to provide scalable and optimized solutions.",
    },
    {
      icon: Progressive_Web,
      title: "Progressive Web Apps",
      desc: "Raiden develops PWAs that combine the best of web and mobile apps. We provide experiences that greatly increase user engagement and lower platform development costs with features like offline functionality, push alerts, faster load times, and installability.",
    },
  ];

  const content = [
    {
      icon: expert_flutter,
      title: "Client Satisfaction",
      desc: "We provide practical solutions for strategic migration or maintenance, guaranteeing business continuity with well-defined plans and predictable results.",
      space: true,
    },
    {
      icon: cost,
      title: "Excellent Performance",
      desc: "Our strategic enhancements include resource caching, DOM optimization, and efficient digest cycle management. We maintain efficiency by optimizing your applications.",
      space: true,
    },
    {
      icon: solution,
      title: "Strategic Enhancements",
      desc: "We integrate security patches through commercial support, ensuring browser compatibility, maintainability, and integration with modern services to extend your app's lifespan.",
      space: false,
    },
    {
      icon: culture,
      title: "Declarative UI Mastery",
      desc: "We create transparent and accessible frameworks using AngularJS' declarative nature, which removes the need for vulnerable critical DOM manipulation.",
      space: false,
    },
    {
      icon: deploy,
      title: "Robust Unit Testing",
      desc: "Our thorough unit testing guarantees the dependability and stability of your application and guards against regressions, which is crucial for legacy systems.",
      space: false,
    },
  ];

  return (
    <>
    <img 
  src={launchingimage} 
  className="Bg-image"
  alt="Launching"
/>

    <div className="main-page-wrapper overflow-hidden">
      <Helmet>
        <title>Customer Support || Deski-Saas & Software React Template</title>
      </Helmet>

      <HeaderThree />
      <div
        className=" container height-vh topheader-margin  d-flex align-items-center justify-content-center flex-column "
    
      >
        <h1 className="h1-heading lh-sm fw-bold text-center">
          AngularJS Development
        </h1>
        <p className="fw-semibold mt-2 h1-para lh-base">
          {" "}
          Reliable & Renowned Services AngularJS{" "} 
        </p>
        <p className="text-center mt-4 mb-4 h1-para lh-base">
          Raiden is the most effective Mobile App Development company,
          offering a wide range of emerging technologies with superior
          solutions. We offer proactive security patches, performance
          optimization, and bug fixes as part of our strategic planning for
          contemporary Angular expert maintenance.
        </p>
        <div className="d-flex ">
          <Link to="/request-quote">
            <button className="h1-para mt-3 py-lg-3 py-2 px-lg-4 px-3 btn-gradient border-0 text-white rounded-4">
              Get Your Free Quote
            </button>
          </Link>
        </div>
      </div>

      <div className=" bg-light">
        <div className=" container pt-50 pb-50">
          <div className=" row mb-80 marb ">
            <h2 className="col-lg-6 lh-sm  h2-heading  ">
              Raiden’s Angular Development Service
            </h2>
            <p className="col-lg-6  h1-para lh-base">
              Our Angular Development Service at Raiden offers reliable,
              state-of-the-art solutions made for the contemporary web. We
              effectively deliver a range of specialized services to our
              intended market, which consists of companies looking for web
              applications that are scalable, high-performing, and future-proof.
            </p>
          </div>

          <div>
            <CoreComponent20 content={content100} />
          </div>
        </div>
      </div>

      <div className="container mt-80 mart ">
        <div className=" row">
          <div className="col-lg-6 text-center mb-3">
            <img src={icon} style={{ width: "75%" }} alt="angular image" />
          </div>
          <div className="col-lg-6">
            <h2 className="h2-heading lh-sm">
              AngularJS Web Development Company
            </h2>
            <p className="mt-4  h1-para lh-base" >
              Raiden provides essential services for your current applications
              and is your strategic partner for AngularJS app development service.
              We ensure customer satisfaction by providing practical solutions
              that guarantee outstanding performance through optimized code and
              efficient processes. Integrating necessary security patches and
              guaranteeing browser compatibility are two examples of our
              strategic enhancement focus. We use the declarative UI of
              AngularJS to write stable code, and we use rigorous unit testing
              to keep things stable. Choose Raiden to protect, maximize, and
              strategically grow your investment in AngularJS.
            </p>
          </div>
        </div>
      </div>

      <div className="container mt-80 mart ">
        <WebDesignCore vertical={vertical} />
      </div>

      <div className="container mt-80 mart ">
        <h2 className="mb-4 text-center h2-heading lh-sm">
          Experience Raiden’s AngularJS Development
        </h2>
        <p className="mb-40 mx-lg-4 text-center  h1-para lh-base ">
          Even for an EOL framework like AngularJS, Raiden provides specialized
          expertise to maximize your existing investment:
        </p>

        <CoreComponent14 content={content} />
      </div>

      <div>
        <CoreComponent2 />
      </div>

      <div className="container text-center mt-80 mart">
        <h2 className="h2-heading lh-sm">
       Mastering the Full Spectrum of Angular JS Development
        </h2>
        <p className="my-3 h1-para lh-base">
          Excellence and Successful Execution
        </p>
        <Enterpertises2 />
      </div>

      <div className="">
        <OurLatestBlogs />
      </div>
      {/* <FaqHome/> */}
      <footer className="theme-footer-two pt-80 padt">
        <div className="top-footer">
          <div className="container">
            <FooterTwo />
          </div>
        </div>
        <div className="container">
          <div className="bottom-footer-content">
            <CopyRightTwo />
          </div>
        </div>
      </footer>
    </div>
    </>
  );
};

export default AngularDevelopment;
